import { forwardRef, useState } from 'react';
import { Tooltip } from "@heroui/react";

export const CustomTooltip = forwardRef(function CustomTooltip({ children, content }, ref) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Tooltip
      ref={ref}
      content={content}
      isOpen={isOpen}
      onOpenChange={(open) => setIsOpen(open)}
      delay={100}
      closeDelay={0}
      classNames={{
        base: '!rounded-md bg-white border shadow-md max-w-[250px] break-words',
      }}
    >
      <div>
        {children}
      </div>
    </Tooltip>
  );
});
